/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiTheme from '@here/lui-base/lui-theme'

export default class LuiDesktoplayerTheme extends LuiTheme {
  constructor() {
    super()
    console.warn(`[LUI] <${this.constructor.is}> component is deprecated and will be removed in future versions.
➜ HINT: Use <lui-default-theme> or <lui-default-theme dark> instead.`)
  }

  static get is() {
    return 'lui-desktoplayer-theme'
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-layer-theme/lui-desktoplayer-theme.js
// module id = 153
// module chunks = 0 1 19